var map = {
	"./15.mp3": "abe6",
	"./16.mp3": "3832",
	"./17.mp3": "71f8",
	"./18.mp3": "509a",
	"./19.mp3": "9ee2",
	"./20.mp3": "ffc2",
	"./21.mp3": "2ec2",
	"./22.mp3": "279f",
	"./23.mp3": "77b4",
	"./24.mp3": "3ce9",
	"./25.mp3": "e10d",
	"./26.mp3": "31a7",
	"./27.mp3": "f97d0",
	"./28.mp3": "1130b",
	"./M_Brilliant.mp3": "3076",
	"./M_Excellent.mp3": "3e71",
	"./M_Fantastic.mp3": "f1cd",
	"./M_Great.mp3": "abf8",
	"./M_Perfect.mp3": "a1f7",
	"./M_Think again.mp3": "b975",
	"./M_Try again.mp3": "7694",
	"./M_Very good.mp3": "e9f1",
	"./M_Well done.mp3": "e27a",
	"./M_Work harder.mp3": "32e8",
	"./click.mp3": "683a",
	"./false.mp3": "ed86",
	"./true.mp3": "cf22"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cbf6";